import React__default from 'react';
import { SVG } from './types.js';

const Chevron = (props) => {
    return (React__default.createElement(SVG, { ...props },
        React__default.createElement("path", { fillRule: 'evenodd', d: 'M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z' })));
};

export { Chevron };
